import React from 'react';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import {ILastResult} from 'features/http/model/HttpMonitor/ILastResult';
import MonitorPingMessageBadge from 'shared/ui/Status/MonitorPingMessageBadge';
import HintQuestion from 'shared/ui/Hint/HintQuestion';

import styles from './LocationsTable.module.scss';

const LocationsTable: React.FC<{results: ILastResult[]}> = ({results}) => {
    return (
        <div className={styles.table}>
            <div className={cn(styles.row, styles.headerRow)}>
                <div className={styles.cell}>{t`Локация`}</div>
                <div className={styles.cell}>{t`Результат`}</div>
                <div className={styles.cell}>{t`Отклик`}</div>
                <div className={styles.cell}>
                    {t`IP агента`}
                    <HintQuestion placement="top" className={styles.icon}>
                        {t`IP-адрес, с которого мониторинговый агент Overseer отправил тестовый запрос`}
                    </HintQuestion>
                </div>
            </div>
            {results.map((result) => (
                <div key={`${result.country}/${result.city}/${result.name}`} className={styles.row}>
                    <div className={styles.cell}>
                        <span className={styles.text}>
                            {result.country}, {result.city}, {result.name}
                        </span>
                    </div>
                    <div className={styles.cell}>
                        <MonitorPingMessageBadge
                            code={Number(result.code)}
                            message={result.message || '—'}
                        />
                    </div>
                    <div className={styles.cell}>
                        <span className={styles.text}>
                            {result.time ? `${result.time} ${t`мс`}` : '—'}
                        </span>
                    </div>
                    <div className={styles.cell}>
                        <span className={styles.text}>
                            {result.ip || '—'}
                        </span>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default LocationsTable;